

import {Component, Vue} from "vue-property-decorator"
import {IAppletBanner} from "@/apis/applet/banner/types"
import config from "@/config";
import type {ICrudOption} from "@/types/m-ui-crud"
import {IPage} from "@/apis/page";
import {getFruitTreeListApi, getPlantationListApi, plantationJobCreateApi, plantationJonQueryApi} from "@/apis/linye";

@Component({})
export default class Job extends Vue {
  config = config
  // 表格加载状态
  tableLoading: boolean = true;
  // 表格数据
  tableData: any[] = []
  // 表格总数
  tableTotal = 0
  // 查询参数
  queryParam: IPage = {
    page: 1,
    limit: 10
  }
  // 表单参数
  modelForm: Partial<any> = {}
  // crud配置信息
  crudOption: ICrudOption = {
    delBtn: false,
    editBtn: false,
    menu: false,
    searchBox: true,
    dialogWidth: '70%',
    labelWidth: '150px',
    column: [
      {
        label: "ID",
        type: "index",
        prop: "id",
        align: "center",
        width: 50,
        addHide: true,
        editHide: true
      },
      {
        label: "种植园名称",
        prop: "plantationName",
        align: "center",
        search: true,
        addHide: true,
        editHide: true
      },
      {
        label: "品种名称",
        prop: "fruitTreeName",
        align: "center",
        search: true,
        addHide: true,
        editHide: true
      },
      {
        label: "种植园",
        prop: "plantationId",
        span: 12,
        search: false,
        hide: true,
        rules: [
          {required: true, message: "请选择种植园", trigger: "blur"}
        ],
        addSlot: true,
        editSlot: true
      },
      {
        label: "品种",
        prop: "fruitTreeId",
        span: 12,
        search: false,
        hide: true,
        rules: [
          {required: true, message: "请选择品种", trigger: "blur"}
        ],
        addSlot: true,
        editSlot: true
      },
      {
        label: "作业类型",
        prop: "jobType",
        align: "center",
        span: 12,
        search: true,
        rules: [
          {required: true, message: "请选择作业类型", trigger: "blur"}
        ],
        type: "select",
        dicData: [{label: "施肥", value: '施肥'}, {label: "浇水", value: '浇水'}, {
          label: "修剪",
          value: '修剪'
        }, {label: "喷药", value: '喷药'}, {label: "播种", value: '播种'}]
      },
      {
        label: "作业日期",
        prop: "jobDate",
        type: "date",
        align: "center",
        span: 12,
        rules: [
          {required: true, message: "请选择采收日期", trigger: "blur"}
        ],
        addSlot: true,
        editSlot: true
      },
      {
        label: "作业人员",
        prop: "handleBy",
        align: "center",
        span: 12,
        rules: [
          {required: true, message: "请输入作业人员", trigger: "blur"}
        ],
        placeholder: "请输入作业人员",
      },
      {
        label: "作业时长",
        prop: "jobTime",
        type: 'number',
        align: "center",
        span: 12,
        placeholder: "请输入作业时长",
        rules: [
          {required: true, message: "请输入作业时长", trigger: "blur"}
        ],
      },
      {
        label: "使用工具",
        prop: "useTool",
        align: "center",
        span: 12,
        placeholder: "请输入使用工具",
      },
      {
        label: "使用肥料",
        prop: "useFertilizer",
        align: "center",
        span: 12,
        placeholder: "请输入使用肥料",
      }, {
        label: "使用量",
        prop: "usage",
        align: "center",
        span: 12,
        placeholder: "请输入使用量",
      },
      {
        label: "备注",
        prop: "remarks",
        maxlength: 200,
        align: "center",
        width: '250px',
        type: "textarea",
      },
      {
        label: "创建时间",
        prop: "addTime",
        align: "center",
        width: '150px',
        addHide: true,
        editHide: true,
      },

    ]
  }
  plantationList: any [] = []
  fruitTreeList: any [] = []

  getList() {
    this.tableLoading = true
    plantationJonQueryApi(this.queryParam).then(e => {
      this.tableData = e.list
      this.tableTotal = e.total
      this.tableLoading = false
    })
  }

  openAdd() {
    getPlantationListApi({}).then(res => {
      this.plantationList = res
    })
    // @ts-ignore
    this.$refs.crudRef.rowAdd()
  }

  plantationChange(e: any) {
    this.fruitTreeList = []
    this.modelForm.fruitTreeId = ''
    getFruitTreeListApi({plantationId: e}).then(res => {
      this.fruitTreeList = res
    })
  }

  rowSave(form: IAppletBanner, done: Function, loading: Function) {
    plantationJobCreateApi(form).then(e => {
      if (e) {
        this.getList()
        this.$message.success("操作成功!")
        done()
      }
    }).finally(() => {
      loading()
    })
  }

  created() {
    this.getList()
  }
}
